export class ProcessingActivityControlDTO {
  processingActivityId: number;

  controlId: number;

  constructor(processingActivityId?: number, controlId?: number) {
    this.processingActivityId = processingActivityId ?? -1;
    this.controlId = controlId ?? -1;
  }
}